/**
 * 全局工具函数/过滤器
 * Created by h on 2019/06/27.
 */
import Vue from "vue";
import store from "../store/store";
import AppConfig from "../appConfig";
import { Message } from "element-ui";

// 判断是否是ie，是则判断是否大于IE9
function IEVersion() {
  let userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  let isIE =
    userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; // 判断是否IE<11浏览器
  let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; // 判断是否IE的Edge浏览器
  let isIE11 =
    userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    let fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return 7;
    } else if (fIEVersion == 8) {
      return 8;
    } else if (fIEVersion == 9) {
      return 9;
    } else if (fIEVersion == 10) {
      return 10;
    } else {
      return 6; // IE版本<=7
    }
  } else if (isEdge) {
    return "edge"; // edge
  } else if (isIE11) {
    return 11; // IE11
  } else {
    return -1; // 不是ie浏览器
  }
}

/**
 * 字符串超出省略号（过滤器）
 * @param val 目标字符串
 * @param num 指定长度
 * */
Vue.filter("wordNumber", (val, num = 20) => {
  if (val.length > num) {
    return val.substring(0, num) + "...";
  } else {
    return val;
  }
});

/**
 * 数据为空过滤器
 * */
Vue.filter("checkNull", val => {
  return !Vue.prototype.checkDataNull(val) ? val : "暂无";
});

/**
 * 格式化金额（默认精确到分）
 * @param val
 * @param decimals 保留小数位数，默认精确至分，金额小数单位：角、分、厘、毫
 * @param dec_point 小数分隔符号
 * @param thousands_sep 金额分隔符（每3位金额分隔一次）
 * */
Vue.filter(
  "money",
  (val, decimals = 2, dec_point = ".", thousands_sep = ",") => {
    let number;

    if (Number(val) > 0) {
      number = Vue.prototype.decimalsLimit(val, decimals);
      let n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
        dec = typeof dec_point === "undefined" ? "." : dec_point,
        s = "",
        toFixedFix = function(n, prec) {
          let k = Math.pow(10, prec);
          return "" + Vue.prototype.accDiv(Vue.prototype.accMul(n, k), k);
        };
      s = (prec ? toFixedFix(n, prec) : "" + Math.floor(n)).split(".");
      let re = /(-?\d+)(\d{3})/;
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
      }
      /* if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    } */
      return "￥" + s.join(dec);
    } else {
      if (val == 0) {
        return val;
      }
      return val;
    }
  }
);

/**
 * 格式化金额（精确到分）
 * 预留于当商品价格需要精确至毫时作为区分
 * @param val
 * */
Vue.filter("moneyCommodity", val => {
  let number,
    decimals = 2,
    dec_point = ".",
    thousands_sep = ", ";

  if (Number(val) > 0 || Number(val) < 0 || Number(val) === 0) {
    number = Vue.prototype.decimalsLimit(val, decimals);
    let n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s = "",
      toFixedFix = function(n, prec) {
        let k = Math.pow(10, prec);
        return "" + Vue.prototype.accDiv(Vue.prototype.accMul(n, k), k);
      };
    s = (prec ? toFixedFix(n, prec) : "" + Math.floor(n)).split(".");
    let re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    /* if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    } */
    return "￥" + s.join(dec);
  } else {
    if (val == 0) {
      return val;
    }
    return val;
  }
});

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.format = function(format) {
  let o = {
    "M+": this.getMonth() + 1, // month
    "d+": this.getDate(), // day
    "h+": this.getHours(), // hour
    "m+": this.getMinutes(), // minute
    "s+": this.getSeconds(), // second
    "q+": Math.floor((this.getMonth() + 3) / 3), // quarter
    S: this.getMilliseconds() // millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
};

/**
 * 时间戳格式化
 * @param format
 * */
String.prototype.timeStampFormat = function(format = "yyyy-MM-dd hh:mm:ss") {
  let time = "";
  if (typeof this === "string") {
    time = parseInt(this);
  }
  let date = new Date(time);
  return date.format(format);
};

/**
 * 清除字符串左右空格
 * */
Vue.prototype.trim = function(s) {
  return Vue.prototype.trimRight(Vue.prototype.trimLeft(s));
};

/**
 * 清除字符串左空格
 * */
Vue.prototype.trimLeft = function(s) {
  if (s == null) {
    return "";
  }
  let whitespace = new String(" \t\n\r");
  let str = new String(s);
  if (whitespace.indexOf(str.charAt(0)) != -1) {
    let j = 0,
      i = str.length;
    while (j < i && whitespace.indexOf(str.charAt(j)) != -1) {
      j++;
    }
    str = str.substring(j, i);
  }
  return str;
};

/**
 * 清除字符串右空格
 * */
Vue.prototype.trimRight = function(s) {
  if (s == null) return "";
  let whitespace = new String(" \t\n\r");
  let str = new String(s);
  if (whitespace.indexOf(str.charAt(str.length - 1)) != -1) {
    let i = str.length - 1;
    while (i >= 0 && whitespace.indexOf(str.charAt(i)) != -1) {
      i--;
    }
    str = str.substring(0, i + 1);
  }
  return str;
};

/**
 * 验证企业用户权限(参数为空则验证超级管理员)
 * @param data 权限类型，必填
 * */
Vue.prototype.checkJurisdiction = (data = "") => {
  let permissionIds = store.state.user.currentIdentityTickPermissionIds;
  if (
    Vue.prototype.checkDataNull(data) ||
    Vue.prototype.checkDataNull(permissionIds) ||
    permissionIds.length === 0
  ) {
    // 不指定
    return false;
  } else {
    if (typeof data !== "String") {
      data = data.toString();
    }
    if (data.indexOf(",") > -1) {
      let permissionList = data.split(",");
      for (let i in permissionList) {
        let item = permissionList[i];
        // 验证指定权限
        if (permissionIds.indexOf(Number(item)) > -1) {
          return true;
        }
      }
      return false;
    } else {
      // 验证指定权限
      if (permissionIds.indexOf(Number(data)) > -1) {
        return true;
      } else {
        return false;
      }
    }
  }
};

/**
 * 验证数据有效性
 * */
Vue.prototype.checkDataNull = val => {
  return (
    typeof val === "undefined" || val === null || val === "" || val.length === 0
  );
};

/**
 * 自动跳转功能
 * @param href      目标连接
 * @param target    跳转方式：默认_blank跳转
 * @param timeout   延长时间（单位：毫秒）
 * */
Vue.prototype.automatic = (href, target = "_blank", timeout = 0) => {
  let a = document.createElement("a");
  a.setAttribute("href", href);
  if (target) {
    a.setAttribute("target", target);
  }

  a.setAttribute("id", "startTelMedicine");
  // 防止反复添加
  if (document.getElementById("startTelMedicine")) {
    document.body.removeChild(document.getElementById("startTelMedicine"));
  }
  document.body.appendChild(a);

  setTimeout(function() {
    // a.click()
    let evt = document.createEvent("MouseEvents");
    evt.initEvent("click", true, true);
    a.dispatchEvent(evt);
  }, timeout);
};

/**
 * josn快速替换指定值
 * @param orig 被替换值目标
 * @param val 替换值目标
 * @param include 指定替换的key列表
 * @param exclude 指定不被替换的key列表
 * */
Vue.prototype.updateJosn = (
  orig = {},
  val = {},
  include = [],
  exclude = []
) => {
  for (let i in val) {
    let item = val[i];
    if (item != null) {
      if (
        orig.hasOwnProperty(i) &&
        (include.length == 0 || include.indexOf(i) > -1) &&
        !(exclude.indexOf(i) > -1)
      ) {
        orig[i] = JSON.parse(JSON.stringify(item));
      }
    }
  }
  return orig;
};

/**
 * 设置cookie
 * @param c_name 键：key
 * @param value  值：value
 * @param expiredays 到期时间
 * */
Vue.prototype.setCookie = (c_name, value, expiredays) => {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    ";path=/" +
    (AppConfig.API.DOMAIN_NAME ? ";domain=" + AppConfig.API.DOMAIN_NAME : "") +
    (expiredays === null ? "" : ";expires=" + exdate.toGMTString()) +
    ";path=/";
};

/**
 * 获取cookie
 * @param name 键：key
 * */
Vue.prototype.getCookie = name => {
  let arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) {
    return arr[2];
  } else {
    return null;
  }
};

/**
 * 删除cookie
 * @param name 键：key
 * */
Vue.prototype.delCookie = name => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  let cval = null;
  if ((arr = document.cookie.match(reg))) {
    cval = arr[2];
  }
  if (cval !== null) {
    document.cookie =
      name +
      "=" +
      cval +
      ";path=/" +
      (AppConfig.API.DOMAIN_NAME
        ? ";domain=" + AppConfig.API.DOMAIN_NAME
        : "") +
      ";expires=" +
      exp.toGMTString();
  }
};

/**
 * 两数求和
 * @param num1
 * @param num2
 * */
Vue.prototype.accAdd = (num1 = 0, num2 = 0) => {
  let r1, r2, m;
  try {
    r1 = num1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = num2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  // return (num1*m+num2*m)/m;
  return Math.round(num1 * m + num2 * m) / m;
};

/**
 * 两数相减
 * @param num1
 * @param num2
 * */
Vue.prototype.accSub = (num1 = 0, num2 = 0) => {
  let r1, r2, m, n;
  try {
    r1 = num1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = num2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  return (Math.round(num1 * m - num2 * m) / m).toFixed(n);
};

/**
 * 两数相除
 * @param arg1  被除数
 * @param arg2  除数
 * */
Vue.prototype.accDiv = (arg1 = 0, arg2 = 1) => {
  let t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split(".")[1].length;
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length;
  } catch (e) {}
  r1 = Number(arg1.toString().replace(".", ""));
  r2 = Number(arg2.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};

/**
 * 两数相乘
 * @param num1  被乘数
 * @param num2  乘数
 * */
Vue.prototype.accMul = (num1 = 0, num2 = 0) => {
  let m = 0,
    s1 = num1.toString(),
    s2 = num2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
};

/**
 * 下载excel文件(默认支持xlsx格式)
 * @param data      文件内容
 * @param fileName  文件名称
 * @param suffix    文件后缀
 * @param blobType  文件配置
 * */
Vue.prototype.downloadExcel = (
  data,
  fileName = "下载",
  suffix = "xlsx",
  blobType = ""
) => {
  // 验证是否是IE且版本大于IE9
  let ieVersion = IEVersion(),
    isIEBrowser = false;

  if (
    ieVersion == "edge" ||
    (Number(ieVersion) > -1 && Number(ieVersion) >= 10)
  ) {
    isIEBrowser = true;
  } else if (Number(ieVersion) > -1 && Number(ieVersion) < 10) {
    Vue.prototype.$message.info("IE浏览器版本请勿低于IE10！");
    return false;
  }

  if (!data) {
    Vue.prototype.$message.info("下载内容为空！");
    return false;
  }

  // let url = window.URL.createObjectURL(new Blob([data]))
  if (!blobType) {
    // 这里表示xlsx类型
    // blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    // blobType = 'application/x-excel'
    blobType = "application/vnd.ms-excel;charset=utf-8";
  }
  let blob = new Blob([data], { type: blobType });

  if (!isIEBrowser) {
    // 非IE浏览器使用的下载方式
    let downloadElement = document.createElement("a");
    let href = window.URL.createObjectURL(blob); // 创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName + "." + suffix; // 下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    document.body.removeChild(downloadElement); // 下载完成移除元素
    window.URL.revokeObjectURL(href); // 释放掉blob对象
  } else {
    // IE或edge浏览器使用的下载方式
    window.navigator.msSaveBlob(blob, fileName + "." + suffix);
  }

  /* let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', 'excel.xlsx')

  document.body.appendChild(link)
  link.click() */
};

/**
 * 下载excel文件 - 用于支持post下载数据(默认xlsx格式)
 * @param data      文件内容（注意需要是blob类型数据） - ajax请求需要设置：responseType:'blob' //--设置请求数据格式
 * @param fileName  文件名称
 * @param suffix    文件后缀
 * */
Vue.prototype.downloadExcel2 = (data, fileName = "excel", suffix = "xlsx") => {
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = window.URL.createObjectURL(data);
  link.setAttribute("download", fileName + "." + suffix);

  document.body.appendChild(link);
  link.click();
};

/**
 * 验证文件类型
 * @param fileName 文件名称
 * @param suffixes 默认限制图片类型，以英文逗号分隔
 */
Vue.prototype.validateFileType = (fileName, suffixes = "jpg,jpeg,png,gif") => {
  let fileTArr = fileName.split(".");
  let fileType = fileTArr[fileTArr.length - 1];

  // 英文转小写
  if (fileType) {
    fileType = fileType.toLowerCase();
  }

  let suffixesList = "";
  let matching = false;
  if (suffixes) {
    suffixesList = suffixes.split(",");
    for (let i in suffixesList) {
      let type = suffixesList[i];
      if (type == fileType) {
        matching = true;
      }
    }
  } else {
    matching = true;
  }

  if (!matching) {
    Message({ message: "上传文件必须为" + suffixes + "类型文件！" });
    return false;
  } else {
    return fileType;
  }
};

/**
 * 验证文件大小
 * @param file      文件对象
 * @param limitSize 文件大小与单位（单位必须大写，支持B，KB，MB，GB）
 * @param error     报错信息
 */
Vue.prototype.validateFileSize = (file, limitSize, error = "") => {
  let arr = ["B", "KB", "MB", "GB"];
  let limit = limitSize.toUpperCase();
  let limitNum = 0;
  for (let i = 0; i < arr.length; i++) {
    let leval = limit.indexOf(arr[i]);
    if (leval > -1) {
      limitNum = parseInt(limit.substr(0, leval)) * Math.pow(1024, i + 2);
      break;
    }
  }
  if (file.size > limitNum) {
    if (!error) error = file.name + "文件大小请勿超过" + limitSize;
    Message({ message: error });
    return false;
  } else {
    return true;
  }
};

// 除法函数，用来得到精确的除法结果
// 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
// 调用：accDiv(arg1,arg2)
// 返回值：arg1除以arg2的精确结果
function accDiv(arg1, arg2) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split(".")[1].length;
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length;
  } catch (e) {}
  r1 = Number(arg1.toString().replace(".", ""));
  r2 = Number(arg2.toString().replace(".", ""));
  if (r2 == 0) {
    return Infinity;
  } else {
    return (r1 / r2) * Math.pow(10, t2 - t1);
  }
}
// 乘法函数，用来得到精确的乘法结果
// 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
// 调用：accMul(arg1,arg2)
// 返回值：arg1乘以arg2的精确结果
function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}

  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
}
// 加法函数，用来得到精确的加法结果
// 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
// 调用：accAdd(arg1,arg2)
// 返回值：arg1加上arg2的精确结果
function accAdd(arg1, arg2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}
// 减法函数
function accSub(arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  // last modify by deeka
  // 动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg2 * m - arg1 * m) / m).toFixed(n);
}

// 给Number类型增加一个add方法，调用起来更加方便。
Number.prototype.add = function(arg) {
  return accAdd(arg, this);
};
// 给Number类增加一个sub方法，调用起来更加方便
Number.prototype.sub = function(arg) {
  return accSub(arg, this);
};
// 给Number类型增加一个mul方法
Number.prototype.mul = function(arg) {
  return accMul(arg, this);
};
// 给Number类型扩展一个div方法
Number.prototype.div = function(arg) {
  return accDiv(this, arg);
};

export { accDiv, accMul, accAdd, accSub };
/**
 * 格式化文件大小
 * @param value 文件对象
 */
Vue.prototype.formateFileSize = value => {
  if (value == null || value == "") {
    return "0B";
  }
  let unitArr = ["B", "KB", "MB", "GB"];
  let index = 0;
  let srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  let size = srcsize / Math.pow(1024, index);
  size = size.toFixed(2); // 保留的小数位数
  return size + unitArr[index];
};

/**
 * 3版下载文件流（使用XMLHttpRequest处理文件流,可在Header添加token）
 * @param url           下载路径
 * @param fileName      文件名称
 * @param fileType      文件类型，可为空
 * @param token         用户token，默认从vuex中自动获取
 * */
Vue.prototype.downloadFile = (
  url,
  fileName = "下载文件",
  fileType = "",
  token = store.state.token
) => {
  let oReq = new XMLHttpRequest();
  oReq.open("GET", url, true);
  oReq.responseType = "blob";
  if (token != "") {
    oReq.setRequestHeader("token", token);
  }
  oReq.onload = function(oEvent) {
    let content = oReq.response;

    let elink = document.createElement("a");
    elink.download = fileName + fileType;
    elink.style.display = "none";

    let blob = new Blob([content]);
    elink.href = URL.createObjectURL(blob);

    document.body.appendChild(elink);
    elink.click();

    document.body.removeChild(elink);
  };
  oReq.send();
};

/**
 * 解除数据双向绑定
 */
Vue.prototype.Unbind = function(val) {
  if (val) {
    return JSON.parse(JSON.stringify(val));
  } else {
    return val;
  }
};

/**
 * 初始化列表数据
 */
Vue.prototype.initList = function(val) {
  if (!val || val === null) {
    return [];
  } else {
    return val;
  }
};

/**
 * 数字小数位数限制（默认两位小数）
 * @param val
 * @param decimals 保留小数位数，默认精确至分，金额小数单位：角、分、厘、毫
 */
Vue.prototype.decimalsLimit = function(val, decimals = 2) {
  if (val) {
    // val = val.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
    // val = val.replace(/^\./g, ""); //验证第一个字符是数字
    // val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
    // val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    // val = val.replace(/^(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入2个小数

    let decimalsReg = new RegExp(
      "^(\\-)*(\\d+)\\.(\\d{1," + decimals + "}).*$"
    );
    val = val
      .toString()
      .replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, "")
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".")
      .replace(/\.{2,}/g, ".")
      .replace(decimalsReg, "$1$2.$3");
  }
  return val;
};

/**
 * 数值小数处理（默认保留两位小数，默认四舍五入）
 * @param {Number} arg1 数值1
 * @param {Number} arg2 数值2
 * @param {String} type 操作类型，accMul相乘、accDiv相除、accSub相减、 accAdd相加
 * @param {Number} decimals 保留小数位数
 * @param {String} mathType 执行类型（参考Math函数）：round四舍五入
 * */
Vue.prototype.calculateSubtotals = function(
  arg1,
  arg2,
  type = "accMul",
  decimals = 2,
  mathType = "round"
) {
  if (arg1 === null || arg2 === null || arg1 === "" || arg2 === "") {
    return null;
  }
  let t = Vue.prototype[type](arg1, arg2);
  t = Vue.prototype.accMul(t, Math.pow(10, decimals));
  t = Vue.prototype.decimalAdjust(mathType, t);
  return Vue.prototype.accDiv(t, Math.pow(10, decimals));
};

/**
 * Decimal adjustment of a number.
 *
 * @param {String}  type  The type of adjustment, reference Math.
 * @param {Number}  value The number.
 * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
 * @returns {Number}      The adjusted value.
 */
Vue.prototype.decimalAdjust = function(type, value, exp) {
  // If the exp is undefined or zero...
  if (typeof exp === "undefined" || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
    return NaN;
  }
  // Shift
  value = value.toString().split("e");
  value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
  // Shift back
  value = value.toString().split("e");
  return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
};

/**
 * 正负数数字两位小数限制
 */
Vue.prototype.GlobalNumberTwoLimit = function(val) {
  if (val) {
    val = val
      .toString()
      .replace("-", "$##$") // 把第一个字符'-'替换成'$##$'
      .replace(".", "$#$") // 把第一个字符'.'替换成'$#$'
      .replace(/\./g, "") // 把其余的字符'.'替换为空
      .replace(/-/g, "") // 把其余的字符'-'替换为空
      .replace("$##$", "-") // 把字符'$#$'替换回原来的'.'
      .replace("$#$", ".") // 把字符'$#$'替换回原来的'.'
      .replace(/[^-{0,1}\d.]/g, "") // 只能输入数字、'.'和'-'
      .replace(/^\./g, "") // 不能以'.'开头
      .replace(/([0-9]+\.[0-9]{2})[0-9]*/, "$1"); // 只保留2位小数
  }
  return val;
};



// WEBPACK FOOTER //
// ./src/util/index.js